import React from "react";
import { Modal, Form, Input } from "antd";


export default function PurchaseLoadTankModal(props) {
  const { open, onClose, target} = props;
  const [form] = Form.useForm();

  return(
    <Modal
      open={open}
      onCancel={onClose}
      okText={"ตกลง"}
      cancelText={"ไม่"}
      title={"Load แท๊งก์"}
      width={400}
    >
      <Form
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 17}}>
        <Form.Item label={'เลือก Lot'}>
          <Input/>
        </Form.Item>
        <Form.Item label={'น้ำหนักโหลด'}>
          <Input/>
        </Form.Item>
      </Form>

    </Modal>
  )
}